import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import useCurrentClinicId from "../../../../hooks/useCurrentClinic";
import useActiveVisit from "../../../../hooks/useActiveVisit";
import {
  BenchmarkInput,
  useBenchmarkSavingMutation,
} from "../../../../graphql/generated";
import { RootState } from "../../../../state/reducers";
import { Medicine } from "./Medicines";

const useMedicine = (token = "") => {
  const clinicId = useCurrentClinicId();
  const { visitId } = useActiveVisit(clinicId);
  const currentDate = new Date().toISOString().split("T")[0];
  const [visitToken, setVisitToken] = useState(token);
  const [createBenchmarkMutation] = useBenchmarkSavingMutation();
  const currentPhysician: string | undefined | null = useSelector(
    (state: RootState) => state.currentUser.currentUser?.givenName
  );
  const alternate = visitToken.concat(
    currentPhysician ?? "[Couldn't Fetch Physician]",
    currentDate
  );

  const benchmark = useCallback(
    (meds: Medicine[]) => {
      const benchmarkInput: BenchmarkInput = {
        benchmarkId: "DoctorEdits-Benchmark-".concat(visitId ?? alternate),
        socialHx: "",
        familyHx: "",
        meds: JSON.stringify({ meds }),
        habits: "",
        discMeds: "",
        MedWarn: "",
        pastMedicalHx: "",
        discPastMedicalHx: "",
        vaccine: "",
        obgyn: "",
        allergies: "",
      };
      console.log(benchmarkInput);
      createBenchmarkMutation({ benchmark: benchmarkInput })
        .then((response) => {
          console.log("[MEDS] Mutation successful:", response);
        })
        .catch((error) => {
          console.error("[MEDS] Mutation failed:", error);
        });
    },
    [createBenchmarkMutation, visitId, alternate]
  );

  // New function to add input to MedWarn
  const addMedWarn = useCallback(
    (medWarnInput: string) => {
      const benchmarkInput: BenchmarkInput = {
        benchmarkId: "DoctorEdits-Benchmark-".concat(visitId ?? alternate),
        socialHx: "",
        familyHx: "",
        meds: "",
        habits: "",
        discMeds: "",
        MedWarn: medWarnInput,
        pastMedicalHx: "",
        discPastMedicalHx: "",
        vaccine: "",
        obgyn: "",
        allergies: "",
      };
      console.log(benchmarkInput);
      createBenchmarkMutation({ benchmark: benchmarkInput })
        .then((response) => {
          console.log("[MedWarn] Mutation successful:", response);
        })
        .catch((error) => {
          console.error("[MedWarn] Mutation failed:", error);
        });
    },
    [createBenchmarkMutation, visitId, alternate]
  );

  //For adding discontinued meds
  const addDiscMed = useCallback(
    (DiscMed: Medicine[]) => {
      const benchmarkInput: BenchmarkInput = {
        benchmarkId: "DoctorEdits-Benchmark-".concat(visitId ?? alternate),
        socialHx: "",
        familyHx: "",
        meds: "",
        habits: "",
        discMeds: JSON.stringify({ DiscMed }),
        MedWarn: "",
        pastMedicalHx: "",
        discPastMedicalHx: "",
        vaccine: "",
        obgyn: "",
        allergies: "",
      };
      console.log(benchmarkInput);
      createBenchmarkMutation({ benchmark: benchmarkInput })
        .then((response) => {
          console.log("[Discontinue Med] Mutation successful:", response);
        })
        .catch((error) => {
          console.error("[Doscontinue Med] Mutation failed:", error);
        });
    },
    [createBenchmarkMutation, visitId, alternate]
  );

  return { benchmark, setVisitToken, addMedWarn, addDiscMed };
};

export default useMedicine;
